import { JsonQueryTerm } from 'shared/models/JsonQueryElement';
import { MapSelectedBounds } from 'shared/store/clientSide/slices/mapControls/slice';
import { JsonQuery } from 'shared/types/JsonQuery';
import { ListingSortType } from 'shared/types/ListingSortType';

export const insertPageToJsonQuery =
  (page: number | null | undefined) =>
  (jsonQuery: JsonQuery): JsonQuery => {
    if (page && page > 1) {
      jsonQuery.page = new JsonQueryTerm(page);
    }

    return jsonQuery;
  };

export const insertSortToJsonQuery =
  (sort: ListingSortType | null | undefined) =>
  (jsonQuery: JsonQuery): JsonQuery => {
    if (sort && sort !== 'default') {
      jsonQuery.sort = new JsonQueryTerm(sort);
    }

    return jsonQuery;
  };

export const insertBboxToJsonQuery =
  (selectedBounds: MapSelectedBounds | undefined) =>
  (jsonQuery: JsonQuery): JsonQuery => {
    if (selectedBounds) {
      jsonQuery.bbox = new JsonQueryTerm(selectedBounds);
    }

    return jsonQuery;
  };
